// search index pag
export const isIndexSelector = `body:has(.openx-ui-main-index)`;

// search map layout
export const isMapSelector = `body:has(.map-layout)`;
export const isDesktopMapSelector = `body:has(.d-map-layout)`;
export const isMobileMapSelector = `body:has(.m-map-layout)`;

// search list layout
export const isListSelector = `body:has(.list-layout)`;
export const isDesktopListSelector = `body:has(.d-list-layout)`;
export const isMobileListSelector = `body:has(.m-list-layout)`;

// search is loading
export const isLoadingSelector = `body:has(.openx-ui-main-loading)`;
